var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasPermissionEx("view") }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPermissionEx("view"),
              expression: "hasPermissionEx('view')"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _vm.$store.getters.isAdmin
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("SMS.agentId")) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "filter-item",
                                    attrs: {
                                      placeholder: _vm.$t("SMS.pleaseChoose"),
                                      clearable: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.queryParameter.agentId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.queryParameter,
                                          "agentId",
                                          $$v
                                        )
                                      },
                                      expression: "queryParameter.agentId"
                                    }
                                  },
                                  _vm._l(_vm.agentOption, function(item) {
                                    return _c("el-option", {
                                      key: item.agentId,
                                      attrs: {
                                        label: item.agentName,
                                        value: item.agentId
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("SMS.orderNumber")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("SMS.pleaseEnterText")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleFilter($event)
                                }
                              },
                              model: {
                                value: _vm.queryParameter.orderNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "orderNo", $$v)
                                },
                                expression: "queryParameter.orderNo"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.$store.getters.isMerchant
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.$t("SMS.organizationName")) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "filter-item",
                                    attrs: {
                                      placeholder: _vm.$t("SMS.pleaseChoose"),
                                      clearable: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value:
                                        _vm.queryParameter.organizationCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.queryParameter,
                                          "organizationCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryParameter.organizationCode"
                                    }
                                  },
                                  _vm._l(_vm.organizationOption, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.organizationName,
                                      attrs: {
                                        label: item.organizationName,
                                        value: item.organizationCode
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("rechargeState.orderState")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.state,
                                  callback: function($$v) {
                                    _vm.$set(_vm.queryParameter, "state", $$v)
                                  },
                                  expression: "queryParameter.state"
                                }
                              },
                              _vm._l(_vm.orderStateOption, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.name, value: item.key }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("SMS.channelName")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.channelId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "channelId",
                                      $$v
                                    )
                                  },
                                  expression: "queryParameter.channelId"
                                }
                              },
                              _vm._l(_vm.channelOption, function(item) {
                                return _c("el-option", {
                                  key: item.channelId,
                                  attrs: {
                                    label: item.channelName,
                                    value: item.channelId
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("SMS.moneyTypeToReport")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.moneyTypeTo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "moneyTypeTo",
                                      $$v
                                    )
                                  },
                                  expression: "queryParameter.moneyTypeTo"
                                }
                              },
                              _vm._l(this.moneyTypeFromOption, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("SMS.statisticsDate")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "filter-item",
                              attrs: {
                                title: _vm.$t("SMS.statisticsDate"),
                                clearable: "",
                                type: "datetimerange",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                "range-separator": "-",
                                "start-placeholder": _vm.$t("common.fromTime"),
                                "end-placeholder": _vm.$t("common.toTime"),
                                "default-time": ["00:00:00", "23:59:59"]
                              },
                              model: {
                                value: _vm.queryParameter.timeList,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "timeList", $$v)
                                },
                                expression: "queryParameter.timeList"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm.viewSummary
                  ? _c("summary-popup", {
                      attrs: { "data-list": _vm.summaryList }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPermissionEx("view"),
                        expression: "hasPermissionEx('view')"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "45" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("order.order_no"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.orderNo
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.orderNo))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin || _vm.$store.getters.isAgent
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.payChannelId"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content:
                                            _vm.$t(
                                              "rechargeOrderRecord.channelName"
                                            ) +
                                            ":" +
                                            _vm.convertChannelIdToName(
                                              scope.row.channelId
                                            ) +
                                            "," +
                                            _vm.$t(
                                              "rechargeOrderRecord.channelID"
                                            ) +
                                            ":" +
                                            scope.row.channelId
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.convertChannelIdToName(
                                                  scope.row.channelId
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            258093462
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.agentId"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content:
                                            _vm.$t("agent.agentLabel") +
                                            "：" +
                                            _vm.convertAgentIdToName(
                                              scope.row.agentId
                                            ) +
                                            " ，" +
                                            _vm.$t("agent.agentIdText") +
                                            "：" +
                                            scope.row.agentId
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.convertAgentIdToName(
                                                  scope.row.agentId
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4117127728
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("message.organizationIDText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      _vm.$t(
                                        "organization.organizationNameText"
                                      ) +
                                      "：" +
                                      _vm.convertOrgCodeToName(
                                        scope.row.organizationCode
                                      ) +
                                      " ，" +
                                      _vm.$t(
                                        "organization.organizationCodeText"
                                      ) +
                                      ":" +
                                      scope.row.organizationCode
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertOrgCodeToName(
                                            scope.row.organizationCode
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.rechargeAmount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      scope.row.processRechargeAmount +
                                      " " +
                                      scope.row.moneyTypeFrom
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.processRechargeAmount +
                                            " " +
                                            scope.row.moneyTypeFrom
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.exchangeRate"),
                        align: "center",
                        "min-width": 50
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.exchangeRate
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.exchangeRate))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.convertAmount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.handleNullMoneyTypeTo(
                                      scope.row
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.handleNullMoneyTypeTo(scope.row)
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.increaseAmount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      _vm.getIncreaseAmount(scope.row) +
                                      " " +
                                      scope.row.moneyTypeFrom
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getIncreaseAmount(scope.row) +
                                            " " +
                                            scope.row.moneyTypeFrom
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin || _vm.$store.getters.isAgent
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.agencyProfit"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: scope.row.processAgentIncome
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.processAgentIncome +
                                                  " " +
                                                  scope.row.moneyTypeFrom
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1741402016
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin || _vm.$store.getters.isAgent
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.superiorAgentIncome"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content:
                                            scope.row.processUpAgentIncome
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.processUpAgentIncome +
                                                  " " +
                                                  scope.row.moneyTypeFrom
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            38035424
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin || _vm.$store.getters.isAgent
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.channelCost"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content:
                                            scope.row.processChannelIncome
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.processChannelIncome +
                                                  " " +
                                                  scope.row.moneyTypeFrom
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            950274208
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin || _vm.$store.getters.isAgent
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.platformProfit"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: scope.row.processProfit
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.processProfit +
                                                  " " +
                                                  scope.row.moneyTypeFrom
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1256516992
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.rechargeStateCode"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.state === 1 ||
                              scope.row.state === 3 ||
                              scope.row.state === 5 ||
                              scope.row.state === 7 ||
                              scope.row.state === 8
                                ? _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.rechargeStateCodeConvert(
                                            scope.row.state
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : scope.row.state === 2 ||
                                  scope.row.state === 4 ||
                                  scope.row.state === 6
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            trigger: "click",
                                            content: scope.row.resMsg
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "reference" },
                                              slot: "reference"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.rechargeStateCodeConvert(
                                                      scope.row.state
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "el-icon-warning",
                                                staticStyle: { color: "red" }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin || _vm.$store.getters.isAgent
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.upNotifyTime"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: _vm.dateFormat(
                                            scope.row.upNotifyTime
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dateFormat(
                                                  scope.row.upNotifyTime
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            228976863
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.downNotifyTime"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.dateFormat(
                                      scope.row.downNotifyTime
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            scope.row.downNotifyTime
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAdmin
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.settleTime"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("sm")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: _vm.dateFormat(
                                            scope.row.settleTime
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dateFormat(
                                                  scope.row.settleTime
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1011961279
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.date"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.dateFormat(
                                      scope.row.createTime
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(scope.row.createTime)
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("common.operationText"),
                        align: "center",
                        "min-width": 400
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("notifyDown"),
                                      expression:
                                        "hasPermissionEx('notifyDown')"
                                    }
                                  ],
                                  staticClass: "filter-item",
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    round: _vm.$store.getters.roundConf,
                                    size: "mini",
                                    type: "success",
                                    icon: "el-icon-sort-down"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleNotifyDown(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.callbackDown")) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx(
                                        "reacquireNotification"
                                      ),
                                      expression:
                                        "hasPermissionEx('reacquireNotification')"
                                    }
                                  ],
                                  staticClass: "filter-item",
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    round: _vm.$store.getters.roundConf,
                                    size: "mini",
                                    type: "warning",
                                    icon: "el-icon-refresh",
                                    disabled: !(scope.row.state === 3)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleReacquireNotification(
                                        scope.row
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.regetNotify")) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("view"),
                                      expression: "hasPermissionEx('view')"
                                    }
                                  ],
                                  staticClass: "filter-item",
                                  attrs: {
                                    disabled: scope.row.upNotifyTime == null,
                                    plain: _vm.$store.getters.plainConf,
                                    round: _vm.$store.getters.roundConf,
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-tickets"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePresentData(
                                        scope.row.orderNo
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.notifyDetail")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermissionEx("view"),
                      expression: "hasPermissionEx('view')"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.queryParameter.pageNum,
                    limit: _vm.queryParameter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog" },
                  [
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          id: "dialog",
                          visible: _vm.dialogFormVisible,
                          width: "700px"
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dialogFormVisible = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card" },
                          [
                            _c("div", { staticClass: "card-title" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("common.notifyDetail")) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "close" }, [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  on: {
                                    click: function($event) {
                                      _vm.dialogFormVisible = false
                                    }
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.formLoading,
                                    expression: "formLoading"
                                  }
                                ],
                                ref: "dataForm",
                                staticStyle: { width: "300px" },
                                attrs: {
                                  rules: _vm.rules,
                                  model: _vm.formTemp,
                                  "label-position": "left",
                                  "label-width": "220px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("order.order_no"),
                                      prop: "orderNo"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.formTemp.orderNo) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("order.msgId"),
                                      prop: "msgId"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.formTemp.msgId) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("order.resMsg"),
                                      prop: "resMsg"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: _vm.formTemp.resMsg
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            staticStyle: {
                                              width: "250px",
                                              display: "block",
                                              overflow: "hidden",
                                              "word-wrap": "break-word"
                                            },
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [_vm._v(_vm._s(_vm.formTemp.resMsg))]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("order.notifyProperty"),
                                      prop: "notifyProperty"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: _vm.formTemp.notifyProperty
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            staticStyle: {
                                              width: "250px",
                                              display: "block",
                                              overflow: "hidden",
                                              "word-wrap": "break-word"
                                            },
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formTemp.notifyProperty
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("order.notifyTime"),
                                      prop: "notifyProperty"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.formTemp.notifyTime) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SMS.createTime"),
                                      prop: "createTime"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.formTemp.createTime) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "actions" }, [
      _c("div", { staticClass: "otherActions" }),
      _vm._v(" "),
      _c("div", { staticClass: "addEditOrDelete" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "actions" }, [
      _c("div", { staticClass: "otherActions" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }